<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BTrkQr/tc-custom/9781641084468.jpg?1717877783819" alt="This image is the cover for the book Only the Brightest Stars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Only the Brightest Stars
      </h1>
      <p class="bookDescription body article font2">
        <p>The problem with being an actor on top of the world is that you have a long way to fall.<br/><br/>Logan Steele is miserable. Hollywood life is dragging him down. Drugs, men, and booze are all too easy. Pulling himself out of his self-destructive spiral, not so much.<br/><br/>Brit Stimple does whatever he can to pay the bills. Right now that means editing porn. But Brit knows he has the talent to make it big, and he gets his break one night when Logan sees him perform on stage.<br/><br/>When Logan arranges for an opportunity for Brit to prove his talent, Brit’s whole life turns around. Brit’s talent shines brightly for all to see, and he brings joy and love to Logan’s life and stability to his out-of-control lifestyle. Unfortunately, not everyone is happy for Logan, and as Brit’s star rises, Logan’s demons marshal forces to try to tear the new lovers apart.  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Grey
      </h2>
      
      <p class="authorDescription body article">Andrew Grey is the author of more than one hundred works of Contemporary Gay Romantic fiction. After twenty-seven years in corporate America, he has now settled down in Central Pennsylvania with his husband of more than twenty-five years, Dominic, and his laptop. An interesting m&eacute;nage. Andrew grew up in western Michigan with a father who loved to tell stories and a mother who loved to read them. Since then he has lived throughout the country and traveled throughout the world. He is a recipient of the RWA Centennial Award, has a master&rsquo;s degree from the University of Wisconsin&ndash;Milwaukee, and now writes full-time. Andrew&rsquo;s hobbies include collecting antiques, gardening, and leaving his dirty dishes anywhere but in the sink (particularly when writing). He considers himself blessed with an accepting family, fantastic friends, and the world&rsquo;s most supportive and loving partner. Andrew currently lives in beautiful, historic Carlisle, Pennsylvania.<BR />Email: andrewgrey@comcast.net<BR />Website: www.andrewgreybooks.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24315ad3